/**
 * Courses Section Selector
 * Renders either partner-specific courses or featured courses based on user's partner tag
 */
'use client';

import { useHasPartnerTag } from '@/hooks/useHasPartnerTag';
import { CardsSectionClient } from './CardsSectionClient';

interface CoursesSectionSelectorProps {
  featuredCoursesSlider?: any;
  partnerSpecificCoursesSlider?: any;
}

export function CoursesSectionSelector({
  featuredCoursesSlider,
  partnerSpecificCoursesSlider,
}: CoursesSectionSelectorProps) {
  const hasPartnerTagFlag = useHasPartnerTag();

  // If user has partner tag, show partner-specific courses
  // When null (during hydration), show featured to avoid layout shift
  if (hasPartnerTagFlag === true && partnerSpecificCoursesSlider) {
    return (
      <section aria-labelledby="partner-courses-heading">
        <CardsSectionClient 
          slider={partnerSpecificCoursesSlider} 
          variant="grid"
        />
      </section>
    );
  }

  // User doesn't have tag or partner courses don't exist, show featured courses
  if (featuredCoursesSlider) {
    return (
      <section aria-labelledby="featured-courses-heading">
        <CardsSectionClient 
          slider={featuredCoursesSlider} 
          variant="default"
        />
      </section>
    );
  }

  // No courses available
  return null;
}
